export const makeChangeEvent = (name: string, value: string) => {
  return {
    target: { name, value },
    currentTarget: { name, value },
  }
};